<template>
  <el-container direction="vertical">
    <el-container>
      <el-table :data="pageData.items" stripe border height="400" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :show-overflow-tooltip="it.key === 'task_desp'">
          <template slot-scope="scope">{{scope.row[it.key]}}</template>
        </el-table-column>

        <el-table-column width="180" label="附件">
          <template slot-scope="scope">
            <ul>
              <li v-for="file in scope.row.task_addition_file_list" :key="file.task_addition_file_id" class="list" @click="viewFile(file)">{{file.file_name}}</li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'

export default {
  data () {
    const taskId = this.rowData.task_id
    return Backend.initListPageNoCache(this, 'task_log', {
      route_name: '任务流程列表',
      tableColList: [
        {
          key: 'user_name',
          name: '处理人',
          fixed: true
        },
        {
          key: 'creation_time',
          name: '处理时间'
        },
        {
          key: 'task_desp',
          name: '处理详情'
        }
      ],
      params: {
        task_id: taskId
      }
    })
  },

  props: ['rowData'],

  methods: {
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0, this.params)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    },
    viewFile (file) {
      const files = file.save_path_url.split('/task_addition_file/')
      const url = files[0] + '/task_addition_file/' + encodeURIComponent(files[1])
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .list{
    cursor: pointer;
    text-decoration: underline;
    color:#e6713a;
    &:hover{
      color: #f23d11;
    }
  }
</style>
